import React, { useEffect, useRef, useState } from 'react'
import GeneralExamination from 'Components/Headers/GeneralExamination'
import Layout from 'Components/Layout'
import { QuestionComponent } from 'Components/Questions'
import { Button, Box, Center, Text } from '@chakra-ui/react'
import {
  useExamAnswerUploadMutation,
  useGetExamQuestionsQuery,
  useLogoutUserMutation,
} from 'Services/API/posp.api'
import { format } from 'date-fns'
import { ToastService } from 'Services/toast.service'
import { useAppSelector, useDeviceType } from 'app/hooks'
import { useDispatch, useSelector } from 'react-redux'
import { resetUser, updateExamResult, updateUserState } from 'features/Authentication'
import { useLocation, useNavigate } from 'react-router-dom'
import { useIdleTimer } from 'react-idle-timer'
import { userState } from 'Constants/userRegistrationStatus'
// import { USER_ID } from 'Constants';

const GeneralInsurance = () => {
  const [answers, setAnswers] = useState<any>({})
  const [indexMap, setIndexMap] = useState<any>({})
  const navigate = useNavigate()
  const [examStatus, setExamStatus] = useState<string>()
  // const [score, setScore] = useState(0)
  const startTime = useRef(format(new Date(), 'yyyy-MM-dd HH:mm'))
  console.log('startTime', startTime)
  const [generalInsuranceQuestions, setGeneralInsuranceQuestions] = useState<any[]>([])

  const { isLoggedIn, authenticatedUser, journeyType } = useSelector((state: any) => state.user)
  const dispatch = useDispatch()
  const location = useLocation()
  // LOGOUT FUNCTIONALITIES

  // const [logoutUser] = useLogoutUserMutation({})

  // const handleLogout = async () => {
  //   try {
  //     const logoutUserResp = await logoutUser({
  //       idle: true,
  //     })
  //     // console.log(logoutUserResp)
  //     if (logoutUserResp?.data?.status && isLoggedIn) {
  //       ToastService.showInfoToast({
  //         title: 'Session Timeout',
  //         message: 'You have been auto logout due to inactivity',
  //       })
  //       navigate('/')
  //       localStorage.clear()
  //       sessionStorage.clear()
  //       dispatch(resetUser())
  //       dispatch(updateUserState(userState))
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }
  // // IDLE TIMER FOR AUTO LOGOUT
  // const [state, setState] = useState<string>('Active')
  // const [count, setCount] = useState<number>(0)
  // const [remaining, setRemaining] = useState<number>(0)

  // const onIdle = () => {
  //   // setState('Idle')
  //   handleLogout()
  // }

  // const onActive = () => {
  //   setState('Active')
  // }

  // const onAction = () => {
  //   setCount(count + 1)
  // }

  // const { getRemainingTime } = useIdleTimer({
  //   onIdle,
  //   onActive,
  //   onAction,
  //   timeout: 10_000 * 6 * 5,
  //   throttle: 500,
  // })

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setRemaining(Math.ceil(getRemainingTime() / 1000))
  //   }, 500)

  //   return () => {
  //     clearInterval(interval)
  //   }
  // })
  const {
    data: generalInsuranceQuestionsResponse,
    isLoading: generalInsuranceQuestionsLoading,
    // refetch: userStateRefetch,
  } = useGetExamQuestionsQuery({ question_type: journeyType })
  console.log('General Page ------------------------->')

  useEffect(() => {
    setGeneralInsuranceQuestions(generalInsuranceQuestionsResponse?.data)
  }, [generalInsuranceQuestionsResponse, generalInsuranceQuestionsLoading])

  const handleAnswerChange = (key: any, value: any, index: number) => {
    setAnswers({ ...answers, [key]: value })

    setIndexMap({ ...indexMap, [index]: true })
  }
  const [submitLifeExamAnswers, { isLoading: submitAnswerLoading }] = useExamAnswerUploadMutation()

  const handleSubmitExam = async () => {
    for (
      let i = 1;
      i <=
      generalInsuranceQuestions?.filter(
        (item) => item?.question_type?.toLowerCase() === journeyType.toLowerCase(),
      ).length;
      i++
    ) {
      if (!indexMap[i]) {
        ToastService.showErrorToast({
          title: 'Attempting all questions are necessary',
          message: `Please attempt question no. ${i}`,
        })

        return
      }
    }
    const answerObject: any[] = []

    Object.keys(answers).forEach((quesid) => {
      answerObject.push({
        question_id: parseInt(quesid),
        selected_opt: answers[quesid],
      })
    })

    const submitObject = {
      user_ans: answerObject,
      journey_type: journeyType,
      exam_start_time: startTime.current,
      exam_end_time: format(new Date(), 'yyy-MM-dd HH:mm'),
    }

    try {
      const examSubmitResp: any = await submitLifeExamAnswers(submitObject).unwrap()
      dispatch(updateExamResult(examSubmitResp.data))
      navigate(
        journeyType === 'LIFE'
          ? '/sp-registration/life-insurance-examination/result'
          : '/sp-registration/general-insurance-examination/result',
      )
    } catch (e) {
      console.log(e, 'error')
    }
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  // console.log(generalInsuranceQuestions)
  return (
    <>
      <Layout HeaderComponent={<GeneralExamination />}>
        {generalInsuranceQuestions &&
          generalInsuranceQuestions
            ?.filter((item) => item?.question_type?.toLowerCase() === journeyType.toLowerCase())
            ?.map((val: any, ind: number) => (
              <div key={ind}>
                <QuestionComponent
                  handleAnswerChange={handleAnswerChange}
                  answers={answers}
                  setAnswers={setAnswers}
                  value={val}
                  number={ind + 1}
                />
              </div>
            ))}

        <Center>
          <Box mt='8%' mb='8%' mr='4%'>
            <Button
              onClick={handleSubmitExam}
              colorScheme='primary'
              p='35% 65% 35% 65%'
              type='submit'
              isDisabled={
                generalInsuranceQuestions?.filter(
                  (item) => item?.question_type?.toLowerCase() === journeyType.toLowerCase(),
                ).length === 0
              }
              isLoading={submitAnswerLoading}
            >
              <Text fontSize='sm'>SUBMIT</Text>
            </Button>
          </Box>
        </Center>
      </Layout>
    </>
  )
}

export default GeneralInsurance
